<template>
  <div id="login" class="login" :class="`login--${showLogoNameOnItsOwn ? 'show-logo-name' : ''}`">
    <form class="form" @submit.prevent="login" @keydown.enter.prevent>
      <div class="form-row">
        <label for="email">Email</label>
        <input type="email" id="email" v-model="email" autocomplete="email" />
      </div>
      <div class="form-row">
        <label for="password">Password</label>
        <input type="password" id="password" v-model="password" autocomplete="current-password" />
      </div>
      <p v-if="!emailVerified" class="error-msg">
        You must click on the link in the email we sent you to verify your email address, before you can log in.
      </p>
      <p v-else-if="!userDataExists" class="error-msg">
        Your user data does not exist.
      </p>
      <p v-else-if="!accountEnabled" class="error-msg">
        Your account has been disabled.
      </p>
      <p v-if="firebaseErrorMessage" class="error-msg">{{ firebaseErrorMessage }} Please <router-link :to="{name: 'register'}">register a new account</router-link>.</p>
      <button class="login-btn" type="submit">Login</button>
    </form>
    <p class="forgotten-password"><router-link :to="{name: 'forgotten-password'}">Forgotten your password? (Not working correctly)</router-link></p>
    <p class="register">Don&rsquo;t have an account? <router-link :to="{name: 'register'}">Register</router-link></p>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import db from './../firebaseInit';
import logUserActivity from './../helpers/logUserActivity';
import {DISABLED_ACCOUNT_LOGIN_PREVENTED, UNABLE_TO_ACCESS_USER_DATA, LOGGED_IN} from './../constants/activityLogs';
import {createNamespacedHelpers} from 'vuex';
import {NOTIFICATION_SETTINGS} from './../constants/globalConstants';

const userVuexModule = createNamespacedHelpers('userVuexModule');

export default {
  name: 'login',
  title: 'Login',
  components: {},
  props: {
    showLogoNameOnItsOwn: Boolean,
  },
  data: function() {
    return {
      email: '',
      password: '',
      emailVerified: true,
      accountEnabled: true,
      userDataExists: true,
      firebaseErrorMessage: '',
      isFirstTimeLoggingIn: false,
    };
  },
  created() {
    this.currentUser = firebase.auth().currentUser;
  },
  computed: {},
  methods: {
    login: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            const currentUser = user.user;
            if (currentUser.emailVerified) {
              db.collection('users')
                .doc(currentUser.uid)
                .get()
                .then(document => {
                  const currentUserData = document.data();
                  this.$store.dispatch('userVuexModule/SET_USER_DATA_FROM_FIREBASE_ACTION', currentUserData);
                  if (currentUserData.enabled) {
                    logUserActivity(LOGGED_IN, () => {
                      this.$store.dispatch('userVuexModule/SET_LAST_LOGGED_IN_AT_ACTION');
                      this.$store.dispatch('userVuexModule/SET_NUM_TIMES_LOGGED_IN_INCREMENT_ACTION');
                      if (currentUserData.gamerTag === '') {
                        this.$router.go({name: 'welcome'});
                      } else {
                        if (this.$route.query.redirect) {
                          this.$router.go({path: this.$route.query.redirect});
                        } else {
                          this.$router.go({name: 'dashboard'});
                        }
                      }
                    });
                  } else {
                    logUserActivity(DISABLED_ACCOUNT_LOGIN_PREVENTED, () => {
                      firebase
                        .auth()
                        .signOut()
                        .then(() => {
                          this.accountEnabled = false;
                        });
                    });
                  }
                })
                .catch(err => {
                  this.$snotify.error('Error getting user data', '', NOTIFICATION_SETTINGS);
                  logUserActivity(UNABLE_TO_ACCESS_USER_DATA, () => {
                    firebase
                      .auth()
                      .signOut()
                      .then(() => {
                        this.userDataExists = false;
                      });
                  });
                });
            } else {
              this.emailVerified = false;
            }
          },
          err => {
            this.firebaseErrorMessage = err.message;
          }
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  padding-top: 2rem;

  &--show-logo-name {
    padding-top: 8rem;
  }
}

.logo {
  width: 21rem;
  margin: 0 auto 1rem auto;
}

.form {
  background-color: var(--text-color-alpha-10);
  border-radius: var(--border-radius);
  margin: 0 auto 7rem auto;
  max-width: 47rem;
  padding: 3rem;
}

.login-btn {
  margin-top: 3rem;
  min-width: 10rem;
}

.forgotten-password,
.register {
  font-size: 1.4rem;
  max-width: none;
  text-align: center;
}

.error-msg {
  text-align: center;
}
</style>
